import React from 'react';
import BooleanStep from './BooleanStep';

export default class SessionSocialReferrerGate extends React.Component {
  render() {
    return (
      <BooleanStep
        {...this.props}
        labelText={ 'Session Social Referrer Gate' }
      />
    );
  }
}
